module.exports = "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MCA1MCIgdmlld0JveD0iMCAwIDUwIDUwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGw9IiNlMjQ3MjYiPjxjaXJjbGUgY3g9IjI1IiBjeT0iMjUiIHI9IjI0LjYiLz48Y2lyY2xlIGN4PSItNDIuNCIgY3k9IjI1IiByPSIyNC42Ii8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/delay-map/Red-Excessive.svg
// module id = 2411
// module chunks = 1